import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-screen-xl px-6 py-32 text-center" data-testid="not-found-page">
      <p className="font-serif text-2xl font-bold text-accent">404</p>
      <h1 className="mt-4 font-serif text-4xl font-bold tracking-tight md:text-5xl">
        This page took a wrong turn.
      </h1>
      <p className="mx-auto mt-5 max-w-md text-sm leading-relaxed text-muted-foreground md:text-base">
        The link you followed might be broken, or the page may have moved.
        Let's get you back somewhere useful.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          data-testid="not-found-home"
          className="flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-sm font-bold text-primary-foreground transition-transform duration-300 hover:scale-[1.03]"
        >
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
        <Link
          to="/find"
          data-testid="not-found-find"
          className="group flex items-center gap-2 rounded-full border border-primary/30 px-7 py-3.5 text-sm font-bold transition-colors hover:bg-primary hover:text-primary-foreground"
        >
          Find a therapist
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  );
}
